/**
 * 弹窗相关 Hooks
 */

import { ref } from 'vue';
import dayjs from 'dayjs';

// @ts-ignore
import $store from '@/sheep/store';

// @ts-ignore
import $helper from '@/sheep/helper';

// @ts-ignore
import test from '@/sheep/helper/test';

// @ts-ignore
import AuthUtil from '@/sheep/api/member/auth';

/** 短信事件类型 */
export type SmsEventType = 'smsLogin' | 'wechat' | 'changeMobile' | 'resetPassword' | 'changePassword';

/**
 * 打开授权弹框
 * @param type 授权类型
 */
export function showAuthModal(type: SmsEventType | string = 'smsLogin'): void {
  const modal = $store('modal');
  console.log('跳转到登录')
  // #ifdef H5
  // closeAuthModal();
  setTimeout(() => {
    modal.$patch((state: { auth: string }) => {
      state.auth = type;
	  uni.navigateTo({ url: '/pages-sub/login/login' })
    });
  }, 200);
  // #endif

  // #ifndef H5
  modal.$patch((state: { auth: string }) => {
    state.auth = type;
	uni.navigateTo({ url: '/pages-sub/login/login' })
  });
  // #endif
}

/**
 * 关闭授权弹框
 */
export function closeAuthModal(): void {
  $store('modal').$patch((state: { auth: string }) => {
    state.auth = '';
  });
}

/**
 * 打开分享弹框
 */
export function showShareModal(): void {
  $store('modal').$patch((state: { share: boolean }) => {
    state.share = true;
  });
}

/**
 * 关闭分享弹框
 */
export function closeShareModal(): void {
  $store('modal').$patch((state: { share: boolean }) => {
    state.share = false;
  });
}

/**
 * 打开快捷菜单
 */
export function showMenuTools(): void {
  $store('modal').$patch((state: { menu: boolean }) => {
    state.menu = true;
  });
}

/**
 * 关闭快捷菜单
 */
export function closeMenuTools(): void {
  $store('modal').$patch((state: { menu: boolean }) => {
    state.menu = false;
  });
}

/**
 * 发送短信验证码
 * @param event 事件类型
 * @param mobile 手机号
 */
export function getSmsCode(event: SmsEventType, mobile: string): void {
  const modalStore = $store('modal');
  const lastSendTimer = modalStore.lastTimer[event];
  if (typeof lastSendTimer === 'undefined') {
    $helper.toast('短信发送事件错误');
    return;
  }

  const duration = dayjs().unix() - lastSendTimer;
  const canSend = duration >= 60;
  if (!canSend) {
    $helper.toast('请稍后再试');
    return;
  }

  if (mobile && !test.mobile(mobile)) {
    $helper.toast('手机号码格式不正确');
    return;
  }

  let scene = -1;
  switch (event) {
    case 'resetPassword':
      scene = 4;
      break;
    case 'changePassword':
      scene = 3;
      break;
    case 'changeMobile':
      scene = 2;
      break;
    case 'smsLogin':
      scene = 1;
      break;
  }

  AuthUtil.sendSmsCode(mobile, scene).then((res: { code: number }) => {
    if (res.code === 0) {
      modalStore.$patch((state: { lastTimer: Record<SmsEventType, number> }) => {
        state.lastTimer[event] = dayjs().unix();
      });
    }
  });
}

/**
 * 获取短信验证码倒计时
 * @param event 事件类型
 * @param mobile 手机号
 * @returns 倒计时文本
 */
export function getSmsTimer(event: SmsEventType, mobile: string = ''): string {
  const modalStore = $store('modal');
  const lastSendTimer = modalStore.lastTimer[event];

  if (typeof lastSendTimer === 'undefined') {
    $helper.toast('短信发送事件错误');
    return '';
  }

  const duration: Ref<number> = ref(dayjs().unix() - lastSendTimer - 60);
  const canSend = duration.value >= 0;

  if (canSend) {
    return '获取验证码';
  }

  setTimeout(() => {
    duration.value++;
  }, 1000);
  return -duration.value.toString() + ' 秒';
}

/** 广告对象 */
export interface Adv {
  imgUrl: string;
}

/**
 * 记录广告弹框历史
 * @param adv 广告对象
 */
export function saveAdvHistory(adv: Adv): void {
  const modal = $store('modal');

  modal.$patch((state: { advHistory: string[] }) => {
    if (!state.advHistory.includes(adv.imgUrl)) {
      state.advHistory.push(adv.imgUrl);
    }
  });
}
